import { render, staticRenderFns } from "./QuestionGroupEdit.vue?vue&type=template&id=1107d4a6&scoped=true&"
import script from "./QuestionGroupEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuestionGroupEdit.vue?vue&type=style&index=0&id=1107d4a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107d4a6",
  null
  
)

export default component.exports